<template>
  <v-container fluid>
    <div v-if="energyPriceSet.id">
      <h2>{{ $tc('energy_price_set') }}: {{ energyPriceSet.description || energyPriceSet.code }}</h2>
      <energy-price-set-form :energy-price-set="energyPriceSet" @saved="energyPriceSetUpdated($event)"></energy-price-set-form>
    </div>
  </v-container>
</template>

<script>
import EnergyPriceSetForm from './EnergyPriceSetForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  components: { EnergyPriceSetForm },
  mixins: [BrowserUtilitiesMixin],
  data () {
    return {
      energyPriceSet: {}
    }
  },
  methods: {
    fetchEnergyPriceSet () {
      this.$orm('EnergyPriceSet')
        .find(this.$route.params.id, {
          params:
          {
            expand: 'customers',
            fields: [
              'id',
              'code',
              'description',
              'type',
              'unit_of_measure',
              'currency',
              'price_history',
              'customers.id',
              'customers.name'
            ].join(',')
          }
        })
        .then((energyPriceSet) => {
          this.energyPriceSet = energyPriceSet

          this.updateBrowserTitle(`${this.$tc('energy_price_set')} ${energyPriceSet.description}`)
        })
        .catch(error => {
          this.handleError(error)
        })
    },
    energyPriceSetUpdated (energyPriceSet) {
      this.$store.dispatch(
        'globalMessagingModule/showSuccessFlashBanner',
        `${this.$i18n.tc('energy_price_set')} ${this.$i18n.t('generic_save_success')}`
      )
    }
  },
  mounted () {
    this.fetchEnergyPriceSet()
  }
}
</script>
